import { useMemo } from 'react';

import { useScope } from 'app/contexts/scopeProvider';

import { useGetRootHierarchies } from 'app/graphql/queries/getRootHierarchies';

import { HierarchyType } from 'app/models';

export type Attribute = {
  name: string;
  column: string;
  type: AttributeType;
};

export type AttributeType = 'string' | 'number' | 'date';

const staticAttributes: Attribute[] = [
  { name: 'Country', column: 'country', type: 'string' },
  { name: 'StateProvince', column: 'region', type: 'string' },
  { name: 'Industry', column: 'industry', type: 'string' },
  { name: 'EffectiveDate', column: 'effectiveDate', type: 'date' },
  { name: 'EndDate', column: 'endDate', type: 'date' }
];

export const useAccountAttributes = () => {
  const { selectedPlanningCycle } = useScope();

  const { data, loading, error } = useGetRootHierarchies({
    fetchPolicy: 'network-only',
    variables: { planningCycleId: selectedPlanningCycle.id }
  });

  const attributes = useMemo(() => {
    const customAttributes =
      data?.getRootHierarchies
        ?.find((root) => root.hierarchyType === HierarchyType.CustomerAccountHierarchy)
        ?.attributes.filter((attribute) => attribute.editable)
        .map(({ name, type }): Attribute => ({ name, column: name, type: type as AttributeType })) ?? [];
    return [...staticAttributes, ...customAttributes];
  }, [data]);

  return { attributes, loading, error };
};
